import { BaseThunkType, InferActionsTypes } from "./store";

import { employeesAPI } from "../api/employees-api";
import { IEmployees } from "../types/employees";
import { servicesAPI } from "../api/services-api";
import { ILanguages } from "../types/services";

const initialState = {
  employees: null as IEmployees | null,
};

type InitialState = typeof initialState;
type Actions = InferActionsTypes<typeof actions>;
type ThunkType = BaseThunkType<Actions>;

const employeesReducer = (
  state = initialState,
  action: Actions
): InitialState => {
  switch (action.type) {
    case "SETTING_EMPLOYEES_DATA": {
      return {
        ...state,
        employees: {
          ...action.payload,
        },
      };
    }
    default:
      return state;
  }
};

export const getEmployees = (): ThunkType => async (dispatch) => {
  try {
    const employees = (await employeesAPI.getEmployees()) as IEmployees;
    dispatch(actions.setEmployees(employees));
  } catch (e) {}
};

export const actions = {
  setEmployees: (employees: IEmployees) =>
    ({ type: "SETTING_EMPLOYEES_DATA", payload: employees } as const),
};

export default employeesReducer;
